import { CouponDto, CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import dayjs from "dayjs"

type CouponState = Omit<CouponEntity, "getWordingDate">
export class CouponEntity {
  value: number
  type: CouponType
  duration: number | null
  createdAt: Date

  private constructor(couponEntity: CouponState) {
    this.value = couponEntity.value
    this.type = couponEntity.type
    this.duration = couponEntity.duration
    this.createdAt = couponEntity.createdAt
  }

  static fromDto(couponDto: CouponDto): CouponEntity {
    return new CouponEntity({
      value: couponDto.value,
      type: couponDto.type,
      duration: couponDto.duration,
      createdAt: new Date(couponDto.createdAt),
    })
  }

  getWordingDate(): string {
    if (this.duration === null) {
      return word("promoCode.date.unlimited", {
        date: dayjs(this.createdAt).format("L"),
      })
    }

    return word("promoCode.date.durationInMonths", {
      dateStart: dayjs(this.createdAt).format("L"),
      dateEnd: dayjs(this.createdAt).add(this.duration, "months").format("L"),
    })
  }
}
